var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 79,
    viewBox: "0 0 6 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32966 78.2475C2.46634 78.3842 2.68795 78.3842 2.82463 78.2475L5.05202 76.0201C5.1887 75.8834 5.1887 75.6618 5.05202 75.5251C4.91534 75.3884 4.69373 75.3884 4.55704 75.5251L2.57715 77.505L0.597246 75.5251C0.460563 75.3884 0.238955 75.3884 0.102271 75.5251C-0.0344121 75.6618 -0.0344121 75.8834 0.102271 76.0201L2.32966 78.2475ZM2.57715 0L2.22715 -1.5299e-08L2.22715 78L2.57715 78L2.92715 78L2.92715 1.5299e-08L2.57715 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepArrow);
export default __webpack_public_path__ + "static/media/step-arrow.189bef02cf70785d364f8696b7eec248.svg";
export { ForwardRef as ReactComponent };